import { ErrorsMap } from './useValidator.types';

export const makeEmptyErrorsMap = <Type extends ErrorsMap>(
  inputNames: ErrorsMap,
): Type => {
  return Object.values(inputNames).reduce(
    (acc, inputName) => ({ ...acc, [inputName]: '' }),
    {},
  ) as Type;
};
